import imagesloaded from "imagesloaded";
import Masonry from 'masonry-layout';

export function init() {
	if($('.single-archive__masonry').length > 0) {
		const grid = new Masonry('.single-archive__masonry', {
			columnWidth: '.grid-sizer',
			itemSelector: '.grid-item',
			percentPosition: true
		})	

		imagesloaded('.single-archive__masonry', function() {
			grid.layout()
		})	

		grid.on('layoutComplete', function() {
			$('.single-archive__masonry').addClass('loaded')
		})
	}
}


// WEBPACK FOOTER //
// ./scripts/components/IssueSingle.js